<template>
  <!-- 顶部合计区 -->
  <div class="total-box" :style="cardBg">
    <div class="total-box-item box-item-first">
      <div class="total-box-frist-text">平台保证金余额</div>
      <div class="frist-num">
        {{ totalOptions.totalAmount | moneyFilter }}
      </div>
      <div class="frist-unit">万元</div>
    </div>
    <div class="total-box-item total-box-second">
      <div class="box-item">
        <div class="total-box-frist-text">
          待审核
          <el-popover placement="right-start" trigger="hover" width="180">
            <div class="custom-content">线下已支付，待平台审核</div>
            <i slot="reference" class="el-icon-warning-outline"></i>
          </el-popover>
        </div>
        <div class="frist-num">
          {{ totalOptions.pendingApprovalAmount | moneyFilter }}
          <div class="frist-unit">万元</div>
        </div>
      </div>
      <div class="box-item">
        <div class="total-box-frist-text">
          冻结中
          <el-popover placement="right-start" trigger="hover" width="160">
            <div class="custom-content">已支付，竞价结束前</div>
            <i slot="reference" class="el-icon-warning-outline"></i>
          </el-popover>
        </div>
        <div class="frist-num">
          {{ totalOptions.freezeAmount | moneyFilter }}
          <div class="frist-unit">万元</div>
        </div>
      </div>
      <div class="box-item">
        <div class="total-box-frist-text">
          履约中
          <el-popover placement="right-start" trigger="hover" width="170">
            <div class="custom-content">竞价结束，订单进行中</div>
            <i slot="reference" class="el-icon-warning-outline"></i>
          </el-popover>
        </div>
        <div class="frist-num">
          {{ totalOptions.performanceAmount | moneyFilter }}
          <div class="frist-unit">万元</div>
        </div>
      </div>
      <div class="box-item">
        <div class="total-box-frist-text">待退款</div>
        <div class="frist-num" style="color: #f56c6c">
          {{ totalOptions.pendingRefundAmount | moneyFilter }}
          <div class="frist-unit" style="color: #1a1a1a">万元</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { axiosTotalUserBondReturn } from "@/api/hy";
import { thousands } from "@/utils/toolset.js";

export default {
  data() {
    return {
      totalOptions: {
        /** 待审批 */
        pendingApprovalAmount: "",
        /** 冻结 */
        freezeAmount: "",
        /** 履约 */
        performanceAmount: "",
        /** 待退回 */
        pendingRefundAmount: "",
        /** 汇总 */
        totalAmount: "",
      },
    };
  },
  computed: {
    // 背景图片
    cardBg() {
      let imgUrl = require(`@/assets/img/bond01.png`);
      return `background-image: url('${imgUrl}');`;
    },
  },
  filters: {
    moneyFilter(value) {
      if (!value) return "0.00";
      return thousands(value / 10000);
    },
  },
  mounted() {
    this.getTotalList();
  },
  methods: {
    async getTotalList() {
      let res = await axiosTotalUserBondReturn({});
      if (res.code == 0) {
        this.totalOptions = res.data;
      } else {
        this.$message.error(res.msg);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.total-box {
  width: 100%;
  height: 170px;
  color: #1a1a1a;
  font-size: 16px;
  background-repeat: no-repeat;
  background-size: 100% 100%;

  .total-box-item {
    height: 50%;
    display: flex;
    justify-content: center;
    align-items: center;

    .total-box-frist-text {
      margin-right: 16px;
    }

    .frist-num {
      font-size: 20px;
      font-weight: 700;
      display: flex;
      align-items: flex-end;
      margin-top: 5px;
      color: #207cfa;
      font-family: Alibaba Sans-Bold;

      .frist-unit {
        color: #1a1a1a;
        font-weight: 400;
        font-size: 12px;
        margin-left: 6px;
        transform: translateY(-4px);
      }
    }
  }
  .total-box-second {
    justify-content: space-around;
    padding: 0 10px;
  }
  .box-item-first {
    .total-box-frist-text {
      transform: translateY(3px);
    }
    .frist-num {
      margin-top: 0;
      font-size: 32px;
    }
    .frist-unit {
      color: #1a1a1a;
      font-weight: 400;
      font-size: 12px;
      margin-left: 6px;
      transform: translateY(3px);
    }
  }
}
</style>
